import React from 'react';
import MaisControleImport from './MaisControle/MaisControleImport';
import './css/Imports.css';

/**
 * Tela de Importações.
 * Componente abstrato que renderiza as seções de importação de cada sistema integrado.
 * Para adicionar uma nova integração, basta criar uma pasta nova (ex: OutroSistema/)
 * e renderizar o componente aqui.
 */
const ImportPage = () => {
  return (
    <section className="content" style={{ marginTop: '30px' }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">

            {/* Seção: MaisControle */}
            <MaisControleImport />

            {/* Futuras integrações podem ser adicionadas aqui */}
            {/* <OutroSistemaImport /> */}

          </div>
        </div>
      </div>
    </section>
  );
};

export default ImportPage;
